"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingFitpayPaymentV2 = void 0;
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var input_output_helper_const_1 = require("@src/const/input-output-helper.const");
var module_mapping_1 = require("@src/const/module.mapping");
var inter_communication_service_1 = require("@src/services/inter-communication.service");
var translation_1 = __importDefault(require("@src/services/translation"));
var cash_dom_1 = __importDefault(require("cash-dom"));
var object_service_1 = require("../../services/object-service");
var fitpay_payment_options_const_1 = require("./const/fitpay-payment-options.const");
var payment_link_helper_1 = require("./payment-link.helper");
/**
 * This class is designed for customer who for some reason got a ML account but their stripe payment was denied later
 * so for those who don't pay their membership via fitpay yet they can refresh / change their payment with this
 * Also maybe usable for customers that want to change their payment option from e.g. paypal to klarna
 */
var MissingFitpayPaymentV2 = /** @class */ (function () {
    function MissingFitpayPaymentV2() {
        this.communicationService = object_service_1.ObjectService.getInstance(inter_communication_service_1.InterCommunicationService);
    }
    MissingFitpayPaymentV2.prototype.loadModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParams, form;
            var _this = this;
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                console.log('Load missing payment');
                (0, generator_const_1._HideErrorMessage)();
                queryParams = (0, payment_link_helper_1.readFitpayLinkQueryParams)(window.location.search);
                if (!queryParams.email || !queryParams.geburtstag) {
                    (0, generator_const_1._ShowErrorMessage)('Ungültiger Link');
                    console.error('Missing params in URL:', queryParams, window.location.search);
                    return [2 /*return*/];
                }
                // payment intent failed
                this.communicationService.subscribeChildren(this).subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
                    var returningFromPayment, $priceElement, price, formattedPrice, $firstnameElement, firstname, $lastnameElement, lastname, defaultSuccessMsg, errorMsg, isSuccessMsg, $message, paymentContainer, paymentContainer;
                    var _a, _b, _c, _d, _e, _f, _g, _h;
                    return __generator(this, function (_j) {
                        switch (_j.label) {
                            case 0:
                                if (data.event === 'initialize' && ((_a = data.module) === null || _a === void 0 ? void 0 : _a.moduleKey) === 'fitpay-payment-element') {
                                    this.stripePaymentElement = data.module.module.instance;
                                }
                                if (!(data.event === 'loaded' && ((_b = data.module) === null || _b === void 0 ? void 0 : _b.moduleKey) === 'fitpay-payment-element')) return [3 /*break*/, 2];
                                return [4 /*yield*/, this.stripePaymentElement.checkPaymentIntentStatus()];
                            case 1:
                                returningFromPayment = _j.sent();
                                if (returningFromPayment.post_payment && !returningFromPayment.payment_success) {
                                    (0, generator_const_1._DeleteLoadingScreen)();
                                    (0, generator_const_1._ShowErrorMessage)('Klarna Bezahlung fehlgeschlagen, bitte erneut versuchen oder Bezahlweise wechseln.');
                                }
                                _j.label = 2;
                            case 2:
                                if (data.event === 'custom' && data.name === 'externalPaymentProviderCallback') {
                                    if (data.value === true) {
                                        this.finishSuccessfulPayment();
                                    }
                                    else {
                                        (0, generator_const_1._ShowErrorMessage)('Bezahlung fehlgeschlagen. Wähle eine andere Methode oder versuche es später erneut.');
                                    }
                                    (0, generator_const_1._DeleteLoadingScreen)();
                                }
                                else if (data.event === 'custom' && data.name === 'loadingFinishedCallback') {
                                    // fitpay module finished creating payment intent
                                    (0, generator_const_1._DeleteLoadingScreen)();
                                    console.log('fitpay loading finished callback');
                                    $priceElement = (0, cash_dom_1.default)("[data-get='missing-payment-amount']");
                                    if ($priceElement.length) {
                                        price = this.stripePaymentElement.paymentIntent.amount;
                                        formattedPrice = (price / 100).toFixed(2);
                                        $priceElement.html(formattedPrice);
                                    }
                                    $firstnameElement = (0, cash_dom_1.default)("[data-get='customer.firstname']");
                                    if ($firstnameElement.length) {
                                        firstname = (_c = this.stripePaymentElement.paymentIntent.customer) === null || _c === void 0 ? void 0 : _c.firstName;
                                        $firstnameElement.html(firstname);
                                    }
                                    $lastnameElement = (0, cash_dom_1.default)("[data-get='customer.lastname']");
                                    if ($lastnameElement.length) {
                                        lastname = (_d = this.stripePaymentElement.paymentIntent.customer) === null || _d === void 0 ? void 0 : _d.lastName;
                                        $lastnameElement.html(lastname);
                                    }
                                }
                                else if (data.event === 'custom' && data.name === 'disableFitpay') {
                                    // payment intent failed, remove payment options and show error
                                    (0, fitpay_payment_options_const_1._RemoveFitpayPaymentOptions)(this.$container);
                                    (0, generator_const_1._DeleteLoadingScreen)();
                                    (_f = (_e = this.module.references.membershipSubmit) === null || _e === void 0 ? void 0 : _e.domElement) === null || _f === void 0 ? void 0 : _f.hide();
                                    this.$container.empty();
                                    defaultSuccessMsg = 'You have no negative balance, no payment needed.';
                                    errorMsg = typeof data.value === 'string' ? data.value : defaultSuccessMsg;
                                    isSuccessMsg = errorMsg === defaultSuccessMsg;
                                    $message = (0, cash_dom_1.default)("\n          <div id=\"".concat(isSuccessMsg ? 'success_msg' : 'error_msg', "\"\n               class=\"").concat(isSuccessMsg ? 'success-msg' : 'error-msg', "\"\n               style=\"\n                 padding:12px;\n                 border:1px solid ").concat(isSuccessMsg ? '#badbcc' : '#f5c2c7', ";\n                 background:").concat(isSuccessMsg ? '#d1e7dd' : '#f8d7da', ";\n                 color:").concat(isSuccessMsg ? '#0f5132' : '#842029', ";\n                 border-radius:8px;\n               \">\n          </div>\n        "));
                                    $message.text(translation_1.default.t(errorMsg));
                                    this.$container.append($message);
                                }
                                else if (data.event === 'custom' && data.name === 'handledReturningPaymentCallback') {
                                    // callback from fitpay if we returned from callback from klarna
                                    console.log('handing returning payment, success:', data.value);
                                    if (data.value) {
                                        (0, fitpay_payment_options_const_1._RemoveAllPaymentOptions)((_g = this.module) === null || _g === void 0 ? void 0 : _g.references);
                                        paymentContainer = this.$container.find("[data-ref='stripe-payment-container']");
                                        if (paymentContainer.length > 0) {
                                            paymentContainer.remove();
                                        }
                                        this.finishSuccessfulPayment(true);
                                    }
                                    else {
                                        (0, generator_const_1._ShowErrorMessage)('Klarna Bezahlung fehlgeschlagen, bitte erneut versuchen oder Bezahlweise wechseln.');
                                        (0, generator_const_1._DeleteLoadingScreen)();
                                    }
                                }
                                else if (data.event === 'custom' && data.name === 'expressValidationFailed') {
                                    // express checkout was successful, but additional data is required
                                    // remove the payment elements to not confuse the customer
                                    // inkasso just hide all payment, usually just captcha missing
                                    (0, generator_const_1._DeleteLoadingScreen)();
                                    (0, fitpay_payment_options_const_1._RemoveAllPaymentOptions)((_h = this.module) === null || _h === void 0 ? void 0 : _h.references);
                                    paymentContainer = this.$container.find("[data-ref='stripe-payment-container']");
                                    if (paymentContainer.length > 0) {
                                        paymentContainer.remove();
                                    }
                                }
                                return [2 /*return*/];
                        }
                    });
                }); });
                (0, generator_const_1._CreateLoadingScreen)();
                if (!((_a = this.module.references.membershipComplete) === null || _a === void 0 ? void 0 : _a.domElement) || !((_b = this.module.references.webflowSubmit) === null || _b === void 0 ? void 0 : _b.domElement)) {
                    console.error('Missing either one of the two data refs: ', module_mapping_1._MembershipCompletionReferences.membershipComplete.uid, 'or', module_mapping_1._MembershipCompletionReferences.webflowSubmit.uid);
                }
                // submit payment (non express)
                (_d = (_c = this.module.references.membershipComplete) === null || _c === void 0 ? void 0 : _c.domElement) === null || _d === void 0 ? void 0 : _d.on('click', function (event) {
                    console.log('submit!!!');
                    event.preventDefault();
                    _this.sendForm();
                });
                // prevent enter submit of the form, or any other indirect submitions
                if ((_e = this.module.references.webflowSubmit) === null || _e === void 0 ? void 0 : _e.domElement) {
                    form = this.module.references.webflowSubmit.domElement.closest('form');
                    (0, input_output_helper_const_1._OverwriteIndirectFormSubmit)(form, function () {
                        _this.sendForm();
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    // remove captcha is used for klarna (external payments), so when coming back you dont need it again
    MissingFitpayPaymentV2.prototype.finishSuccessfulPayment = function (removeCaptcha) {
        var _a, _b;
        if (removeCaptcha === void 0) { removeCaptcha = false; }
        if (removeCaptcha) {
            var captchaRes = this.$container.find("#g-recaptcha-response");
            if (captchaRes.length) {
                captchaRes.remove();
            }
        }
        console.log('Submitting webflow form');
        (_b = (_a = this.module.references.webflowSubmit) === null || _a === void 0 ? void 0 : _a.domElement) === null || _b === void 0 ? void 0 : _b.trigger('click');
    };
    MissingFitpayPaymentV2.prototype.sendForm = function () {
        return __awaiter(this, void 0, void 0, function () {
            var recaptchaResponse, isRecaptchaInvalid, stripeRes, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.info('SUBMIT PAYMENT');
                        recaptchaResponse = document.getElementById('g-recaptcha-response');
                        isRecaptchaInvalid = recaptchaResponse && recaptchaResponse.value.trim() === '';
                        console.log('Captcha invalid?', isRecaptchaInvalid);
                        if (isRecaptchaInvalid) {
                            (0, generator_const_1._ShowErrorMessage)('Bitte Captcha ausfüllen');
                            return [2 /*return*/, false];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        (0, generator_const_1._CreateLoadingScreen)();
                        (0, generator_const_1._HideErrorMessage)();
                        return [4 /*yield*/, this.stripePaymentElement.startPaymentProcess(undefined)];
                    case 2:
                        stripeRes = _a.sent();
                        console.log('perform stripe request', stripeRes);
                        (0, generator_const_1._DeleteLoadingScreen)();
                        if (stripeRes.success === true) {
                            this.finishSuccessfulPayment();
                        }
                        else {
                            (0, generator_const_1._ShowErrorMessage)(translation_1.default.t(stripeRes.message || 'Payment failed'));
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.log('payment error', e_1);
                        (0, generator_const_1._ShowErrorMessage)(typeof e_1 === 'string' ? e_1 : 'Something went wrong with your payment');
                        (0, generator_const_1._DeleteLoadingScreen)();
                        return [2 /*return*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return MissingFitpayPaymentV2;
}());
exports.MissingFitpayPaymentV2 = MissingFitpayPaymentV2;
